import React, {useEffect} from "react";
import {FormControl} from "@material-ui/core";

import {
  AssetDataLocationObject,
  DataLocation,
} from "common/flowmaster/types/data_location";
import {
  ActionDefinition,
  StringArgument,
  WorkflowTask,
} from "common/flowmaster/types/task_config";
import {
  Prompt,
  WorkflowContext,
  WorkflowInputs,
} from "common/flowmaster/types/workflow";
import {OrganisationId} from "common/types/organisation";
import ContainedTextField from "../../contained_text_field";
import {StringArgEditor} from "../string";

interface AssetEditorProps {
  location: AssetDataLocationObject;
  onUpdateItem: (value: AssetDataLocationObject) => void;
  priorTasks: WorkflowTask[];
  context: WorkflowContext;
  inputs: WorkflowInputs;
  prompts: Prompt[];
  actionDefinitions: ActionDefinition[];
  organisationId: OrganisationId;
  handleHasError?: (value: boolean) => void;
  disabled?: boolean;
}

const AssetEditor: React.FC<AssetEditorProps> = ({
  location,
  onUpdateItem,
  priorTasks,
  context,
  inputs,
  prompts,
  actionDefinitions,
  organisationId,
  handleHasError,
  disabled,
}) => {
  const keyUndefined = location.key === undefined;
  const locationUndefined = location.value === undefined;
  const error = keyUndefined || locationUndefined;

  useEffect(() => {
    if (handleHasError) {
      handleHasError(error);
    }
  }, [error]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "1em",
        width: "100%",
      }}
    >
      <FormControl disabled={disabled} style={{width: "100%"}}>
        <ContainedTextField
          initialValue={location.key}
          label="Asset Key"
          onUpdate={key => onUpdateItem({...location, key})}
          errorMessage={keyUndefined ? "Key cannot be empty" : undefined}
        />
      </FormControl>
      <StringArgEditor
        argValue={{
          value: location.value as DataLocation<string>,
        }}
        priorTasks={priorTasks}
        context={context}
        inputs={inputs}
        prompts={prompts}
        actionDefinitions={actionDefinitions}
        onUpdateItem={({value}: StringArgument) => {
          onUpdateItem({
            ...location,
            value,
          });
        }}
        organisationId={organisationId}
        useAsset={false}
        handleHasError={handleHasError}
      />
    </div>
  );
};

export default AssetEditor;
